import { queryGenerator } from "../../hooks/queries/queries";

import { getAllLegalEntites } from "./services";

export const useGetAllLegalEntities = queryGenerator(getAllLegalEntites);
